import type {
  FeatureConfig,
  FeatureConfigValue,
  SiteSpecificFeatureConfigValue,
} from '../types';

import { brandingFeature } from './brandingFeature';
import { cartEditFlowFeature } from './cartEdtiFlow';
import { keySellingPointsFeature } from './keySellingPointsFeature';
import { mandatoryQuestionsFeature } from './mandatoryQuestionsFeature';
import { paywallFeature } from './paywall';
import { perUnitBillingFeature } from './perUnitBillingFeature';
import { privateAdFeature } from './privateAdFeature';
import { sponsoredSlotFeature } from './sponsoredSlotFeature';

export const featureConfigs: (
  | FeatureConfig<SiteSpecificFeatureConfigValue>
  | FeatureConfig<FeatureConfigValue>
)[] = [
  brandingFeature,
  cartEditFlowFeature,
  keySellingPointsFeature,
  paywallFeature,
  mandatoryQuestionsFeature,
  paywallFeature,
  perUnitBillingFeature,
  privateAdFeature,
  sponsoredSlotFeature,
];
